import { PathParam } from "react-router-dom";

// In previous versions of react-router, the `generatePath` function would resolve both path and query parameters.
// In the latest versions, it only resolves path parameters.
// This function generates a URL with both path and query parameters based on a template.
// This is the exact legacy implementation of `generatePath` from react-router v6.4.1.
// https://github.com/remix-run/react-router/blob/react-router-dom%406.4.1/packages/router/utils.ts#L477C17-L477C29
export function generateUrlWithPathAndParamsOrThrow<Path extends string>(
  path: Path,
  params: {
    [key in PathParam<Path>]: string;
  } = {} as any
): string {
  return path
    .replace(/:(\w+)/g, (_, key: PathParam<Path>) => {
      invariant(params[key] != null, `Missing ":${key}" param`);
      return params[key]!;
    })
    .replace(/(\/?)\*/, (_, prefix, __, str) => {
      const star = "*" as PathParam<Path>;

      if (params[star] == null) {
        // If no splat was provided, trim the trailing slash _unless_ it's
        // the entire path
        return str === "/*" ? "/" : "";
      }

      // Apply the splat
      return `${prefix}${params[star]}`;
    });
}

function invariant(value: any, message?: string) {
  if (value === false || value === null || typeof value === "undefined") {
    throw new Error(message);
  }
}
